export default {
  title: 'Verilen İnşaat Ruhsatları',
  x_axis: 'Yıl',
  y_axis: 'Ruhsat Sayısı',
  districts: {
    Alanya: 'Alanya',
    Konyaalti: 'Konyaaltı',
    Kemer: 'Kemer',
    Kepez: 'Kepez',
    Dosemealti: 'Döşemealtı',
    Finike: 'Finike'
  }
}
